function App() {
  return (
    <div className="App">
      <section className="max-w-2xl mt-32 px-8 mb-4 space-y-4">
        <p className="leading-7 text-4">Hey there, it's nice to meet you. I'm Marge Consunji. I build things with React and Astro, mostly, but am always open to exploring different technologies. When I'm not at my desk, you can find me drawing, baking, hanging out with my cats 🐱 or out hiking.</p>
      </section>
      {/* <section className="max-w-2xl mt-32 px-8 mb-4 space-y-4">
      </section> */}
    </div>
  );
}

export default App;
